module.exports = __webpack_public_path__ + "static/img/首页-B@3x.2e45496.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/bottom/首页-B@3x.png
// module id = 1250
// module chunks = 382